import {useRef} from "react";

export function useGetUnique(prefix = null) {
    const counterRef = useRef(0)

    function getUniqueId() {
        if (prefix)
            return prefix + "_" + ++counterRef.current
        return ++counterRef.current
    }

    return {getUniqueId}
}